
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {Account} from '../core/Account';
import {FieldModelAccount} from '../core/Account';
import {TradeHistoryRecord} from '../entity/TradeHistoryRecord';
import {FieldModelTradeHistoryRecord} from '../entity/TradeHistoryRecord';
import {AccountMarginStable} from '../entity/AccountMarginStable';
import {FieldModelAccountMarginStable} from '../entity/AccountMarginStable';
import {Asset} from '../core/Asset';
import {FieldModelAsset} from '../core/Asset';
import {Order} from '../core/Order';
import {FieldModelOrder} from '../core/Order';

/**
 * AccountDelete2Response struct
 */
class AccountDelete2Response extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Account=} account
   * @param {!TradeHistoryRecord=} accountTradeHistoryRecord
   * @param {AccountMarginStable=} accountMargin
   * @param {!Array=} assets
   * @param {!Array=} orders
   * @constructor
   */
  constructor (parent = new Response(), account = new Account(), accountTradeHistoryRecord = new TradeHistoryRecord(), accountMargin = null, assets = [], orders = []) {
    super()
    super.copy(parent)
    this.Account = account
    this.AccountTradeHistoryRecord = accountTradeHistoryRecord
    this.AccountMargin = accountMargin
    this.Assets = assets
    this.Orders = orders
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountDelete2Response}
   * @param {!AccountDelete2Response} other Other struct
   * @returns {!AccountDelete2Response} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Account != null) {
      this.Account = Account.fromObject(other.Account)
    } else {
      this.Account = null
    }
    if (other.AccountTradeHistoryRecord != null) {
      this.AccountTradeHistoryRecord = TradeHistoryRecord.fromObject(other.AccountTradeHistoryRecord)
    } else {
      this.AccountTradeHistoryRecord = null
    }
    if (other.AccountMargin != null) {
      this.AccountMargin = AccountMarginStable.fromObject(other.AccountMargin)
    } else {
      this.AccountMargin = null
    }
    if (other.Assets != null) {
      this.Assets = []
      for (let item of other.Assets) {
        if (item != null) {
          let tempItem
          tempItem = Asset.fromObject(item)
          this.Assets.push(tempItem)
        } else {
          this.Assets.push(null)
        }
      }
    } else {
      this.Assets = null
    }
    if (other.Orders != null) {
      this.Orders = []
      for (let item of other.Orders) {
        if (item != null) {
          let tempItem
          tempItem = Order.fromObject(item)
          this.Orders.push(tempItem)
        } else {
          this.Orders.push(null)
        }
      }
    } else {
      this.Orders = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountDelete2Response}
   * @returns {!AccountDelete2Response} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountDelete2ResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountDelete2ResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountDelete2Response}
   * @param {!AccountDelete2Response} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountDelete2Response)) {
      throw new TypeError('Instance of AccountDelete2Response is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountDelete2Response}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Account: ((this.Account != null) ? this.Account : null),
      AccountTradeHistoryRecord: ((this.AccountTradeHistoryRecord != null) ? this.AccountTradeHistoryRecord : null),
      AccountMargin: ((this.AccountMargin != null) ? this.AccountMargin : null),
      Assets: ((this.Assets != null) ? Array.from(this.Assets, item => ((item != null) ? item : null)) : null),
      Orders: ((this.Orders != null) ? Array.from(this.Orders, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountDelete2Response.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountDelete2Response} other Object value
   * @returns {!AccountDelete2Response} Created struct
   */
  static fromObject (other) {
    return new AccountDelete2Response().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountDelete2Response}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountDelete2Response.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountDelete2Response}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4068
  }
}

export { AccountDelete2Response };

/**
 * Fast Binary Encoding AccountDelete2Response field model
 */
class FieldModelAccountDelete2Response extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.Account = new FieldModelAccount(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.AccountTradeHistoryRecord = new FieldModelTradeHistoryRecord(buffer, this.Account.fbeOffset + this.Account.fbeSize)
    this.AccountMargin = new fbe.FieldModelOptional(new FieldModelAccountMarginStable(buffer, this.AccountTradeHistoryRecord.fbeOffset + this.AccountTradeHistoryRecord.fbeSize), buffer, this.AccountTradeHistoryRecord.fbeOffset + this.AccountTradeHistoryRecord.fbeSize)
    this.Assets = new fbe.FieldModelVector(new FieldModelAsset(buffer, this.AccountMargin.fbeOffset + this.AccountMargin.fbeSize), buffer, this.AccountMargin.fbeOffset + this.AccountMargin.fbeSize)
    this.Orders = new fbe.FieldModelVector(new FieldModelOrder(buffer, this.Assets.fbeOffset + this.Assets.fbeSize), buffer, this.Assets.fbeOffset + this.Assets.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelAccountDelete2Response}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountDelete2Response}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountDelete2Response}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Account.fbeSize + this.AccountTradeHistoryRecord.fbeSize + this.AccountMargin.fbeSize + this.Assets.fbeSize + this.Orders.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountDelete2Response}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Account.fbeExtra + this.AccountTradeHistoryRecord.fbeExtra + this.AccountMargin.fbeExtra + this.Assets.fbeExtra + this.Orders.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountDelete2Response}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountDelete2Response.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountDelete2Response}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4068
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountDelete2Response}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountDelete2Response}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Account.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Account.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Account.fbeSize

    if ((fbeCurrentSize + this.AccountTradeHistoryRecord.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountTradeHistoryRecord.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountTradeHistoryRecord.fbeSize

    if ((fbeCurrentSize + this.AccountMargin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountMargin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMargin.fbeSize

    if ((fbeCurrentSize + this.Assets.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Assets.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Assets.fbeSize

    if ((fbeCurrentSize + this.Orders.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Orders.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Orders.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountDelete2Response}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountDelete2Response}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountDelete2Response}
   * @param {!AccountDelete2Response} fbeValue Default value, defaults is new AccountDelete2Response()
   * @returns {!AccountDelete2Response} AccountDelete2Response value
   */
  get (fbeValue = new AccountDelete2Response()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountDelete2Response}
   * @param {!AccountDelete2Response} fbeValue AccountDelete2Response value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Account.fbeSize) <= fbeStructSize) {
      fbeValue.Account = this.Account.get()
    } else {
      fbeValue.Account = new Account()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Account.fbeSize

    if ((fbeCurrentSize + this.AccountTradeHistoryRecord.fbeSize) <= fbeStructSize) {
      fbeValue.AccountTradeHistoryRecord = this.AccountTradeHistoryRecord.get()
    } else {
      fbeValue.AccountTradeHistoryRecord = new TradeHistoryRecord()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountTradeHistoryRecord.fbeSize

    if ((fbeCurrentSize + this.AccountMargin.fbeSize) <= fbeStructSize) {
      fbeValue.AccountMargin = this.AccountMargin.get()
    } else {
      fbeValue.AccountMargin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMargin.fbeSize

    if ((fbeCurrentSize + this.Assets.fbeSize) <= fbeStructSize) {
      this.Assets.get(fbeValue.Assets)
    } else {
      fbeValue.Assets.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Assets.fbeSize

    if ((fbeCurrentSize + this.Orders.fbeSize) <= fbeStructSize) {
      this.Orders.get(fbeValue.Orders)
    } else {
      fbeValue.Orders.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Orders.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountDelete2Response}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountDelete2Response}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountDelete2Response}
   * @param {!AccountDelete2Response} fbeValue AccountDelete2Response value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountDelete2Response}
   * @param {AccountDelete2Response} fbeValue AccountDelete2Response value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Account.set(fbeValue.Account)
    this.AccountTradeHistoryRecord.set(fbeValue.AccountTradeHistoryRecord)
    this.AccountMargin.set(fbeValue.AccountMargin)
    this.Assets.set(fbeValue.Assets)
    this.Orders.set(fbeValue.Orders)
  }
}

export { FieldModelAccountDelete2Response };

/**
 * Fast Binary Encoding AccountDelete2Response model
 */
class AccountDelete2ResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountDelete2Response(this.buffer, 4)
  }

  /**
   * Get the AccountDelete2Response model
   * @this {!AccountDelete2ResponseModel}
   * @returns {!FieldModelAccountDelete2Response} model AccountDelete2Response model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountDelete2ResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountDelete2ResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountDelete2ResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountDelete2ResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountDelete2Response.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountDelete2ResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountDelete2ResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountDelete2ResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountDelete2ResponseModel}
   * @param {!AccountDelete2Response} value AccountDelete2Response value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountDelete2ResponseModel}
   * @param {!AccountDelete2Response} value AccountDelete2Response value, defaults is new AccountDelete2Response()
   * @return {!object} Deserialized AccountDelete2Response value and its size
   */
  deserialize (value = new AccountDelete2Response()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountDelete2Response(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountDelete2Response(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountDelete2ResponseModel}
   * @param {!number} prev Previous AccountDelete2Response model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountDelete2ResponseModel };
